import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from '../../services/coreService';
import { LanguageService } from '../../language.service';
import { CommonModule } from '@angular/common';
interface TranslationObject {
  location: string;
  carRequested: string;
  requestedTime: string;
  riyadhPark: string;
  description: string;
  amount: string;
  valetFees: string;
  total: string;
  sar: string;
  carParkedAt: string;
  checkInTime: string;
  keySlotNo: string;
  requestMyCar: string;
}
@Component({
    selector: 'app-demo-page',
    templateUrl: './demo-page.component.html',
    styleUrls: ['./demo-page.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class DemoPageComponent implements OnInit {
  currentStep: number = 3;
  currentLanguage: string;
  logo = environment.logo_path;
  private sub: any;
  selectedLanguage="en";
  detail:any;
  requested_vehicle:any;
  pay_response:any;
  currentTranslation: TranslationObject;
  encryptedId: string;
  
  // Coupon related properties
  showCheckoutUI: boolean = false;
  couponCode: string = '';
  couponApplied: boolean = false;
  couponResponse: any = null;
  isApplyingCoupon: boolean = false;
  couponError: string = '';
  
  // Drop-off location properties
  dropOffLocations: any[] = [];
  selectedDropOffLocationId: string = '';
  isRequestingCar: boolean = false;

  constructor(private languageService: LanguageService,private route: ActivatedRoute,public coreService: CoreService, private router: Router) { 
    
   
  }

  ngOnInit(): void {
    this.updateTranslation();
    this.currentLanguage = this.languageService.getLanguage();
    this.sub = this.route.params.subscribe(params => {
      
      this.encryptedId = params["id"];
    });
    this.route.queryParams.subscribe(queryParams => {
      if (queryParams["status"]) {
        const status = queryParams["status"];
        if (status === "3") {
          this.router.navigate(['valet-payment-failed/'+this.encryptedId]);    
        }else if(status === "2"){
          this.router.navigate(['valet-payment-success/'+this.encryptedId]);
        }
        else{
          this.getDetails(this.encryptedId);

        } 
      }else{
        this.getDetails(this.encryptedId);

      }
    });
    
  }

  changeLanguage(): void {
    const newLanguage = this.languageService.getLanguage() === 'eng' ? 'arb' : 'eng';
    this.languageService.setLanguage(newLanguage);
    this.updateTranslation();
    
  }

  private updateTranslation(): void {
    this.currentTranslation = this.languageService.getCurrentLanguageObject();
    this.currentLanguage = this.languageService.getLanguage();

  }

  getTerms(){    
    this.router.navigate(['terms-conditions/'+this.selectedLanguage]);    
  }



  getDetails(id){
    this.coreService.GetDetails(id)
    .toPromise()
    .then((response : any) => {
      this.detail=response.data;      
      console.log(this.detail);
      
      // Store drop-off locations if available
      if(this.detail.drop_off_locations && this.detail.drop_off_locations.length > 0) {
        this.dropOffLocations = this.detail.drop_off_locations;
        // Automatically select the first location by default
        const firstLocation = this.dropOffLocations[0];
        this.selectedDropOffLocationId = Object.keys(firstLocation)[0];
      }
      
      this.statusUpdate(this.detail.valet_parking_status);
      if(this.currentStep == 2){
        this.vehicleDetail();
      }
    
    })  
  }
 
  vehicleDetail(){
    this.isRequestingCar = true;
    this.coreService.GetVehicleDetails(this.detail.id, this.selectedDropOffLocationId)
     .toPromise()
     .then((response : any) => {
      this.requested_vehicle=response.data;
      console.log(this.requested_vehicle)
      this.statusUpdate(this.requested_vehicle.valet_parking_status);
      this.isRequestingCar = false;
      
      // Auto-refresh the page after successful request
      setTimeout(() => {
        this.getDetails(this.encryptedId);
      }, 500);
     })
     .catch((error: any) => {
       console.error('Error requesting car:', error);
       this.isRequestingCar = false;
     })
  }
  payForVehicle(){

    if(this.requested_vehicle){

      this.coreService.PayForVehiclePayment(this.requested_vehicle.currency === 'KWD' ? 'pass-valet/hesabe-transactions-pass-valet/':'pass-valet/transactions-tap-valet/',
        {
          "amount": this.requested_vehicle.amount,
          "type": "debit",
          "currency": this.requested_vehicle.currency,
          "valet_ticket_id": this.detail.id,
        }
      )
       .toPromise()
       .then((response : any) => {
        console.log(response)
        this.pay_response=response;
        console.log(this.pay_response)
        this.redirectToPayment(this.pay_response.payment_url);
  
  
       })    
    }
    else{
      console.error("No vehicle details available for payment.");
    }
  }
  redirectToPayment(url) {
    window.location.href = url;
  }

  // Show checkout UI instead of direct payment
  showCheckout() {
    this.showCheckoutUI = true;
  }

  // Apply coupon code
  applyCoupon() {
    if (!this.couponCode.trim()) {
      this.couponError = 'Please enter a coupon code';
      return;
    }

    this.isApplyingCoupon = true;
    this.couponError = '';

    const couponData = {
      valet_ticket_id: this.detail.id,
      coupon_code: this.couponCode.trim()
    };

    this.coreService.ApplyValetCoupon(couponData)
      .toPromise()
      .then((response: any) => {
        console.log('Coupon applied successfully:', response);
        // The response comes with data property
        this.couponResponse = response.data;
        this.couponApplied = true;
        this.isApplyingCoupon = false;
        
        // Update the detail object with new amounts
        this.detail.amount = this.couponResponse.amount;
        this.detail.discounted_amount = this.couponResponse.discounted_amount;
        this.detail.total_discount_amount = this.couponResponse.total_discount_amount;
      })
      .catch((error: any) => {
        console.error('Error applying coupon:', error);
        this.couponError =  'Invalid coupon code';
        this.isApplyingCoupon = false;
      });
  }

  // Proceed to payment after coupon application
  proceedToPayment() {
    const finalAmount = this.couponApplied ? this.couponResponse.discounted_amount : this.requested_vehicle.amount;
    
    // If amount is zero, call charge-with-zero-amount API
    if (parseFloat(finalAmount) === 0) {
      this.chargeWithZeroAmount();
    } else {
      // Call existing payment gateway APIs
      this.payForVehicleWithAmount(finalAmount);
    }
  }

  // Charge with zero amount
  chargeWithZeroAmount() {
    const data = {
      valet_ticket_id: this.detail.id
    };

    this.coreService.ChargeWithZeroAmount(data)
      .toPromise()
      .then((response: any) => {
        console.log('Zero amount charge successful:', response);
        // Navigate to success page
        this.router.navigate(['valet-payment-success/' + this.encryptedId]);
      })
      .catch((error: any) => {
        console.error('Error with zero amount charge:', error);
        // Navigate to failed page
        this.router.navigate(['valet-payment-failed/' + this.encryptedId]);
      });
  }

  // Pay with specific amount
  // ottu payment gateway integrated
  payForVehicleWithAmount(amount: string) {
    if (this.requested_vehicle) {
      this.coreService.PayForVehiclePayment(
        this.requested_vehicle.currency === 'KWD' ? 'pass-valet/hesabe-transactions-pass-valet/' : 'backend/payment_ksa/valet-create_payment/',
        {
          "amount": amount,
          "type": "debit",
          "currency": this.requested_vehicle.currency,
          "valet_ticket_id": this.detail.id,
        }
      )
      .toPromise()
      .then((response: any) => {
        console.log(response);
        this.pay_response = response;
        console.log(this.pay_response);
        this.redirectToPayment(this.pay_response.payment_url);
      })
      .catch((error: any) => {
        console.error('Payment error:', error);
      });
    } else {
      console.error("No vehicle details available for payment.");
    }
  }

  // Helper method for parseFloat to use in template
  parseFloat(value: string): number {
    return parseFloat(value);
  }

  statusUpdate(updated_on){
    if(updated_on=='checked_in' || updated_on =='parked' )
      {
        this.currentStep = 1;
      }else if(updated_on=='requested')
        {
          this.currentStep = 2;
        }     
        else if(updated_on=='on-the-way')
        {
          this.currentStep = 3;
        }
        else if(updated_on=='checkout' || updated_on=='delivered')
        {
          this.currentStep = 4;
        }
  }
  
  // Helper method to get location name from the drop-off location object
  getLocationName(location: any): string {
    const key = Object.keys(location)[0];
    return location[key];
  }
  
  // Helper method to get location ID from the drop-off location object
  getLocationId(location: any): string {
    return Object.keys(location)[0];
  }
}
